import { adaptDocumentSkillStep1 } from "./step1";
import { SkillForm } from "@/core/skillForms/types";

export const adaptDocumentSkillForm: SkillForm = {
  skillId: "adapt_document",
  title: "Adaptar peça/contrato",
  steps: [adaptDocumentSkillStep1],
};
